// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xk_Om","content":"styles_content__n3jw6","row":"styles_row__3PNV3","footer":"styles_footer__eya5L","phraseLength":"styles_phraseLength__2Nrfu"};